namespace GeniuzPOS.PosShift {
    export interface PosTranDiscRow {
        Id?: number;
        DocNo?: string;
        LineItemNo?: number;
        LineItemType?: string;
        DiscCouponType?: string;
        DiscCouponNo?: string;
        PromoId?: string;
        DiscPc?: number;
        Discamt?: number;
        ChargePc?: number;
        ChargeAmt?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PosTranDiscRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'PosShift.PosTranDisc';
        export const lookupKey = 'PosShift.PosTranDisc';

        export function getLookup(): Q.Lookup<PosTranDiscRow> {
            return Q.getLookup<PosTranDiscRow>('PosShift.PosTranDisc');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            DocNo = "DocNo",
            LineItemNo = "LineItemNo",
            LineItemType = "LineItemType",
            DiscCouponType = "DiscCouponType",
            DiscCouponNo = "DiscCouponNo",
            PromoId = "PromoId",
            DiscPc = "DiscPc",
            Discamt = "Discamt",
            ChargePc = "ChargePc",
            ChargeAmt = "ChargeAmt",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
